<template>
  <VueDatePicker :model-value="modelValue || value" @update:model-value="setDate" format="yyyy/MM/dd" :preset-dates="dataPresetDates" auto-apply />
</template>

<script>
import moment from 'moment'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
export default {
  components: {
    VueDatePicker
  },
  data() {
    return {
      dates: {
        'Today': {
          label: 'Today',
          value: [moment().startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        'Yesterday': {
          label: 'Yesterday',
          value: [moment().subtract(1, 'days').startOf('day').toDate(), moment().subtract(1, 'days').endOf('day').toDate()]
        },
        'This Week': {
          label: 'This Week',
          value: [moment().startOf('week').toDate(), moment().endOf('week').toDate()]
        },
        'Last Week': {
          label: 'Last Week',
          value: [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]
        },
        '7 Days Ago': {
          label: '7 Days Ago',
          value: [moment().subtract(7, 'days').startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        'This Month': {
          label: 'This Month',
          value: [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
        },
        'Last Month': {
          label: 'Last Month',
          value: [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
        },
        '30 Days Ago': {
          label: '30 Days Ago',
          value: [moment().subtract(30, 'days').startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        '3 Months Ago': {
          label: '3 Months Ago',
          value: [moment().subtract(3, 'months').startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        '90 Days Ago': {
          label: '90 Days Ago',
          value: [moment().subtract(90, 'days').startOf('day').toDate(), moment().endOf('day').toDate()]
        },
        'This Year': {
          label: 'This Year',
          value: [moment().startOf('year').toDate(), moment().endOf('year').toDate()]
        }
      }
    }
  },
  computed: {
    dataPresetDates() {
      let dates = []
      if (!this.presetDates) return dates
      this.presetDates.forEach((item) => {
        if (_.isString(item)) {
          if (this.dates?.[item]) dates.push(this.dates?.[item])
        } else if (_.isString(item?.label) && _.isArray(item?.value)) {
          dates.push(item)
        }
      })
      return dates
    }
  },
  methods: {
    setDate(value) {
      if (this.format && value) value = value.map((item) => moment(item).format(this.format))
      this.$emit('change', value)
      this.$emit('update:modelValue', value)
    }
  },
  props: {
    modelValue: {
      type: [String, Date, Number, Array],
      default() {
        return null
      }
    },
    value: {
      type: [String, Date, Number, Array],
      default() {
        return null
      }
    },
    format: {
      type: String,
      default() {
        return null
      }
    },
    presetDates: Array
  }
}
</script>
<style lang="scss">
.dp__input_wrap {
  input {
    max-width: 100% !important;
  }
}
.date-picker-left {
  .dp__outer_menu_wrap {
    left: 0 !important;
  }
}
</style>
